import 'isomorphic-fetch';
import { BffLoggerCall } from '../typings/model-overview';
import { ReviewModel, ReviewsApiConfig } from '../typings/reviews';
import { AppConstants } from '../utils/app-constants';
import _ from 'lodash';
import {
  REVIEWS_ENDPOINT,
  createFetchReviewsUrl,
  createReviewServerHeaders,
} from './fetch-helpers';

export interface FetchFeedbackReviews {
  readonly reviewsHostData?: ReviewsApiConfig;
  readonly model: string;
  readonly rating?: string;
  readonly page?: number;
  readonly type?: string;
  readonly size?: number;
  readonly dataVersion: string;
  readonly apiKeyContent?: string;
}
export class FeedbackReviewsFetchError extends Error {
  public constructor(
    message: string,
    public readonly bffLoggerCalls?: BffLoggerCall[],
  ) {
    super('Fetch Reviews Error: ' + message);
  }
}

/**
 * Create five stars object params
 * @param model
 * @param rating
 * @param page
 * @param type
 * @param size
 * @returns object
 */
const createReviewsRequestParams = (
  dataVersion: string,
  model: string,
  rating?: string,
  page?: number,
  type?: string,
  size?: number,
): URLSearchParams => {
  let params = new URLSearchParams();
  params.set('dv', dataVersion);
  params.set('model', model);
  params.set('filter_category_key', type || AppConstants.SurveyType);
  if (rating) params.set('filter_stars', rating);
  if (page) params.set('offset', `${page}`);
  if (size) params.set('limit', `${size}`);
  return params;
};

export async function fetchFeedbackReviews({
  reviewsHostData,
  model,
  rating,
  page,
  type =  AppConstants.SurveyType,
  size,
  dataVersion,
  apiKeyContent,
}: FetchFeedbackReviews): Promise<ReviewModel> {
  if (!reviewsHostData)
    throw new FeedbackReviewsFetchError('Host url is undefined');
  if (!model) throw new FeedbackReviewsFetchError('Model name is undefined');
  if (!dataVersion) {
    throw new FeedbackReviewsFetchError('Data version is undefined');
  }
  const reviewsParams = createReviewsRequestParams(
    dataVersion,
    model,
    rating,
    page,
    type,
    size,
  );
  const { apiEnvironmentKey } = reviewsHostData.customConfig as any;

  const reviewsRequestUrl = createFetchReviewsUrl(
    reviewsHostData,
    'reviewsProductPath',
    reviewsParams,
    REVIEWS_ENDPOINT,
  );
  const requestHeaders = createReviewServerHeaders(
    apiKeyContent || apiEnvironmentKey,
  );
  const request = await fetch(reviewsRequestUrl, { headers: requestHeaders });
  const response = await request.json();

  if (request.status >= 500) {
    throw new FeedbackReviewsFetchError(response.message);
  }
  if (_.isEmpty(response))
    throw new FeedbackReviewsFetchError('No reviews data');
  return response;
}
